import { useEffect, useState } from "react";
import { Flame, Loader2 } from "lucide-react";
import { buyBundle } from "@/lib/buy";

const links = [
  { label: "How it works", href: "#how", testId: "nav-link-how" },
  { label: "Product", href: "#buy", testId: "nav-link-product" },
  { label: "FAQ", href: "#faq", testId: "nav-link-faq" },
  { label: "Journal", href: "/blog", testId: "nav-link-journal" },
  { label: "Community", href: "/community", testId: "nav-link-community" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [buying, setBuying] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur border-b border-stone-200 shadow-sm" : "bg-white/0"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-md bg-[#f97316] flex items-center justify-center">
            <Flame size={16} className="text-white" strokeWidth={2.4} />
          </span>
          <span className={`font-display font-bold tracking-[0.15em] text-sm ${scrolled ? "text-[#17150f]" : "text-white"}`}>
            NOXWAY<span className="align-super text-[9px] text-[#f97316]">™</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className={`text-sm font-medium transition-colors ${
                scrolled ? "text-stone-600 hover:text-[#f97316]" : "text-white/85 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => {
            setBuying(true);
            buyBundle("noxway_formula_100");
            setTimeout(() => setBuying(false), 1500);
          }}
          disabled={buying}
          data-testid="nav-buy-button"
          className="inline-flex items-center gap-2 font-display font-bold text-sm px-5 py-2.5 rounded-md bg-[#f97316] text-white hover:bg-[#ea580c] transition-colors disabled:opacity-70"
        >
          {buying && <Loader2 size={13} className="animate-spin" />}
          BUY NOW
        </button>
      </div>
    </header>
  );
}
